import {Component, NgZone, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SalesPortalService} from 'src/app/services/sales-portal.service';
import {TimeMode, SplittingMethod} from 'src/app/pages/sales-portal/product-group-table/product-group-table.component'


@Component({
  selector: 'workshop-acquisition-setting',
  templateUrl: './workshop-acquisition-setting.component.html',
  styleUrls: ['./workshop-acquisition-setting.component.less']
})


export class WorkshopAcquisitionSettingComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private zone: NgZone,
    public salesPortalService: SalesPortalService,
  ) {
  }

  editStatus: boolean = false
  editTargetProcurement: boolean = false
  splittingMethod: SplittingMethod = 'manualSplitting'
  time: TimeMode = ''
  isSpinning: boolean = false
  detailInfo: any = {}


  get workshopRemaining() {
    const target = this.detailInfo.targetCustomer;
    if (Array.isArray(this.detailInfo.customerConfigurationList) && this.detailInfo.customerConfigurationList.length > 0) {
      let sum = this.detailInfo.customerConfigurationList.reduce((total: any, group: { targetAmount: any; }) => {
        return total + group.targetAmount;
      }, 0);
      return Number((target - sum)?.toFixed(2))
    } else {
      return 0
    }
  }

  ngOnInit(): void {
    document.body.classList.add('sales-portal-body');

    this.route.queryParams.subscribe(params => {
      const query = {
        targetYear: params['targetYear'],
        dealerCode: params['dealerCode'],
        dealerOrgCode: params['dealerOrgCode'],
        dealerChannelCode: params['dealerChannelCode'],
      }
      this.getDetail(query)
    });
  }

  ngOnDestroy(): void {
    document.body.classList.remove('sales-portal-body');
  }

  getDetail(params: object) {
    this.isSpinning = true
    this.salesPortalService.customerTargetSplitDetail(params).subscribe((result: any) => {
      const {rtnCode, rtnData} = result;
      if (rtnCode === 10000) {
        this.detailInfo = rtnData
      }
      this.isSpinning = false
    }, () => {
      this.isSpinning = false
    });
  }

  navigate(path: string): void {
    this.router.navigate([path]);
  }

  handleEdit() {
    this.editStatus = true
    this.time = this.detailInfo.expandCustomerSplitMethod
  }

  handleCancel() {
    this.editStatus = false
  }

  handleSave() {
    this.isSpinning = true
    this.salesPortalService.saveCustomerClassification(this.detailInfo).subscribe((result: any) => {
      const {rtnCode} = result;
      if (rtnCode === 10000) {
        this.router.navigate(['/sales-portal/workshop-acquisition'])
      }
      this.isSpinning = false
    }, () => {
      this.isSpinning = false
    });
  }

  handleTimeChange() {
    this.zone.run(() => {
      this.detailInfo.expandCustomerSplitMethod = this.time
      if (this.time === 'BY_MONTH') {
        this.handleChangeToMonth()
      } else if (this.time === 'BY_QUARTER') {
        this.handleChangeToQuarter()
      } else if (this.time === 'BY_YEAR') {
        this.handleChangeToYear()
      }
    });
  }

  handleChangeToMonth() {
    this.detailInfo.customerConfigurationList = this.salesPortalService.MONTH_ARRAY.map(monthItem => {
      return {
        name: monthItem,
        targetAmount: 0,
        actualAmount: 0
      }
    })
  }

  handleChangeToQuarter() {
    this.detailInfo.customerConfigurationList = this.salesPortalService.QUARTER_ARRAY.map(quarterItem => {
      return {
        name: quarterItem,
        targetAmount: 0,
        actualAmount: 0
      }
    })
  }

  handleChangeToYear() {
    this.detailInfo.customerConfigurationList = [this.detailInfo.targetYear].map(yearItem => {
      return {
        name: yearItem,
        targetAmount: 0,
        actualAmount: 0
      }
    })
  }
}
